import { useSearchParams } from "react-router-dom";

export const useNumFromQuery = (
  name: string,
  defaultValue?: number
): number | undefined => {
  const [searchParams] = useSearchParams();

  let paramValue = searchParams.get(name);
  const value = paramValue
    ? parseInt(paramValue)
    : defaultValue
    ? defaultValue
    : undefined;

  return value;
};
